export const CAPABILITY_KEY = {
  X_N: 'X_N',
  X_I: 'X_I',
  X_1: 'X_1',
  X_P: 'X_P',
  X_Y: 'X_Y',
  X_II: 'X_II',
  X_PI: 'X_PI',
  X_PS: 'X_PS',
  EXPRESS_ECONOMY: 'X_H',
  PS: 'PS',
  DOOR: 'DOOR',
  BP: 'BP',
  REFERENCE: 'REFERENCE',
  PERS_NOTE: 'PERS_NOTE',
  EA: 'EA',
  INS: 'INS',
  NBB: 'NBB',
  NO_TT: 'NO_TT',
  PRINTLESS: 'PRINTLESS',
  PICKUP: 'PICKUP',
  HAND_OFF_SP: 'HAND_OFF_SP',
  EXPRESS_PAPERLESS_TRADE: 'X_WY',
}

export const CARRIER = {
  PARCEL: 'DHL-PARCEL',
  EXPRESS: 'DHL-EXPRESS',
  // Not a real carrier, but a different variant of DHL-EXPRESS, which
  // offers a cheaper, slower option.
  EXPRESS_ECONOMY: 'DHL-EXPRESS-ECONOMY',
}

export const EXPRESS_CUSTOMS = {
  PROFORMA: 'PRO-FORMA',
  COMMERCIAL: 'COMMERCIAL',
}

export const PARCEL_CUSTOMS = {
  GIFT: 'GIFT',
  COMMERCIAL: 'COMMERCIAL',
}

export const CUSTOM_TYPES = {
  [CARRIER.PARCEL]: PARCEL_CUSTOMS,
  [CARRIER.EXPRESS]: EXPRESS_CUSTOMS,
  [CARRIER.EXPRESS_ECONOMY]: EXPRESS_CUSTOMS,
}

export const PROMOTION = {
  UNVERIFIED: 'UNVERIFIED',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
}

export const EXPORT_TYPES = {
  Permanent: 'Permanent',
  Return: 'Repair/Return',
  Temporary: 'Temporary',
}

export const EXPORT_REASONS = {
  Other: 'Other',
  Gift: 'Gift',
  ReturnedGoods: 'Returned item',
  CommercialSample: 'Product sample',
  SaleOfGoods: 'Commercial good',
  Documents: 'Documents',
}

export const PACKAGE = 'package'
export const SHIPPER = 'shipper'
export const CUSTOMS = 'customs'
export const OVERVIEW = 'overview'
export const RECEIVER = 'receiver'
export const LABEL = 'label'
export const SUMMARY = 'summary'
export const PAYMENT = 'payment'
export const PAYMENT_FAILURE = 'payment-failure'

export const STEP_NAME = {
  PACKAGE,
  RECEIVER,
  SHIPPER,
  CUSTOMS,
  OVERVIEW,
  PARCELSHOP_PAYMENT: PAYMENT,
  SUMMARY,
  LABEL,
}

export const PARCEL_TYPE = {
  ENVELOPE: 'ENVELOPE',
  XXSMALL: 'XXSMALL',
  XSMALL: 'XSMALL',
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE',
  XLARGE: 'XLARGE',
  XXLARGE: 'XXLARGE',
}

export const MINIMAL_PICKUP_WINDOW = 3

export const basketSessionStorageName = 'basket-state'
